import { Box, Link, Typography } from "@mui/material"
import React from "react"
import { customPalette } from "../../../../../../../../theme"
import { IconInfoCircle } from "../../../../../../../components/custom-icons/icon-info-circle"
import { BSVariantCreateButton } from "./BSVariantCreateButton"

export function BSVariantListEmpty(): React.JSX.Element {
  return (
    <Box display="flex" flexDirection="column" justifyContent="center" alignItems="center" gap={2} width="80%">
      <Typography fontSize="24px" fontWeight={600} lineHeight="36px" color={customPalette.darkBlue3} textAlign="center">
        Estimez le poids carbone de vos bâtiments comme un pro en quelques minutes
      </Typography>
      <Typography variant="body1" py={1} textAlign="center">
        Avec ou sans maquette BIM, réalisez vos estimations carbone en un temps record et appuyez vos engagements grâce à des
        tableaux de bord interactifs et dynamiques.
      </Typography>
      {/*<ValidateButton label="Ajouter une estimation" onClick={action} />*/}
      <BSVariantCreateButton />

      <Box display="flex" alignItems="center" gap={1}>
        <IconInfoCircle sx={{ color: customPalette.black }} />
        <Typography variant="body1" py={1} textAlign="center">
          C'est quoi une estimation Shot ? On vous explique 👉
        </Typography>
        <Link
          href="https://timetobeem.com/piloter-carbone-faisabilite/"
          underline="hover"
          target="_blank"
          rel="noopener noreferrer">
          timetobeem.com/piloter-carbone-faisabilite
        </Link>
      </Box>
    </Box>
  )
}
